<div [formGroup]="form" class="condition-group" [class.half-width]="isHalfWidth">
  <div class="field">
    <label class="checkbox">
      <input type="checkbox" formControlName="RequireAllConditions">
      Require All Conditions
    </label>
  </div>

  <div class="conditions" formArrayName="Conditions">
    @for (condition of conditions.controls; track condition; let i = $index) {
      <div [formGroupName]="i" class="condition mb-3">
        <!-- Condition Type Selection -->
        <div class="field mb-2">
          <div class="control">
            <!-- Show dropdown only if condition doesn't have an Id or Id is 0 -->
            @if (!condition.get('Id')?.value || condition.get('Id')?.value === 0) {
              <div class="select">
                <select formControlName="ClassName" (change)="onConditionTypeChange(i)">
                  <option value="SignConfigurationDisplayRuleThresholdCondition">Threshold</option>
                  <option value="SignConfigurationDisplayRuleTimeCondition">Time</option>
                  <option value="SignConfigurationDisplayRuleDayOfWeekCondition">Day of Week</option>
                </select>
              </div>
            }
            <!-- Show condition type as text if condition has an Id -->
            @if (condition.get('Id')?.value && condition.get('Id')?.value > 0) {
              <div class="has-text-weight-bold">
                @if (condition.get('ClassName')?.value === 'SignConfigurationDisplayRuleThresholdCondition') {
                  <span>Threshold</span>
                }
                @if (condition.get('ClassName')?.value === 'SignConfigurationDisplayRuleTimeCondition') {
                  <span>Time</span>
                }
                @if (condition.get('ClassName')?.value === 'SignConfigurationDisplayRuleDayOfWeekCondition') {
                  <span>Day of Week</span>
                }
              </div>
            }
          </div>
        </div>
        <!-- Condition Fields -->
        <div class="field is-horizontal">
          <div class="field-body">
            <!-- Threshold Condition -->
            @if (condition.get('ClassName')?.value === 'SignConfigurationDisplayRuleThresholdCondition') {
              <div class="field">
                <div class="control">
                  <div class="select">
                    <select formControlName="TargetThresholdProperty">
                      @for (prop of modelProperties; track prop) {
                        <option [value]="prop.Name">{{prop.Name}}</option>
                      }
                    </select>
                  </div>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <div class="select">
                    <select formControlName="TargetThresholdOperator">
                                        <option value="=">=</option>
                                        <option value="<"><</option>
                                        <option value="<="><=</option>
                                        <option value=">">></option>
                                        <option value=">=">>=</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" formControlName="Value">
                            </div>
                        </div>
                    
}

                    <!-- Time Condition -->
                    @if (condition.get('ClassName')?.value === 'SignConfigurationDisplayRuleTimeCondition') {

                        <div class="field">
                            <div class="control">
                                <input class="input" type="time" formControlName="Time">
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <div class="select">
                                    <select formControlName="Operator">
                                        <option value="=">=</option>
                                        <option value="<"><</option>
                                        <option value="<="><=</option>
                                        <option value=">">></option>
                                        <option value=">=">>=</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    
}

                    <!-- Day of Week Condition -->
                    @if (condition.get('ClassName')?.value === 'SignConfigurationDisplayRuleDayOfWeekCondition') {

                        <div class="field is-grouped is-grouped-multiline">
                            <div class="control">
                                <label class="checkbox">
                                    <input type="checkbox" formControlName="ActiveMonday"> Mon
                                </label>
                            </div>
                            <div class="control">
                                <label class="checkbox">
                                    <input type="checkbox" formControlName="ActiveTuesday"> Tue
                                </label>
                            </div>
                            <div class="control">
                                <label class="checkbox">
                                    <input type="checkbox" formControlName="ActiveWednesday"> Wed
                                </label>
                            </div>
                            <div class="control">
                                <label class="checkbox">
                                    <input type="checkbox" formControlName="ActiveThursday"> Thu
                                </label>
                            </div>
                            <div class="control">
                                <label class="checkbox">
                                    <input type="checkbox" formControlName="ActiveFriday"> Fri
                                </label>
                            </div>
                            <div class="control">
                                <label class="checkbox">
                                    <input type="checkbox" formControlName="ActiveSaturday"> Sat
                                </label>
                            </div>
                            <div class="control">
                                <label class="checkbox">
                                    <input type="checkbox" formControlName="ActiveSunday"> Sun
                                </label>
                            </div>
                        </div>
                    
}

                    <div class="field">
                        <div class="control">
                            <button class="button is-danger is-small" (click)="removeCondition(i)">
                                <span class="icon">
                                    <i class="fas fa-times"></i>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
}
    </div>

    <div class="child-groups" formArrayName="ChildGroups">
        @for (group of childGroups.controls; track group; let i = $index) {
<div class="child-group mb-3">
            <app-condition-group
                [form]="getFormGroup(group)"
          [modelProperties]="modelProperties"
          (remove)="removeChildGroup(i)"
          [canRemove]="true"
          [mode]="mode">
        </app-condition-group>
      </div>
    }
  </div>

  <div class="buttons">
    <button class="button is-primary is-small" (click)="addCondition()">
      <span class="icon">
        <i class="fas fa-plus"></i>
      </span>
      <span>Add Condition</span>
    </button>
    <button class="button is-info is-small" (click)="addChildGroup()">
      <span class="icon">
        <i class="fas fa-layer-group"></i>
      </span>
      <span>Add Child Group</span>
    </button>
    @if (canRemove) {
      <button class="button is-danger is-small" (click)="remove.emit()">Remove Group</button>
    }
  </div>
</div>